export default "__VITE_ASSET__Db2hRct4__"